import { useContext } from "react"
import { useLocation, useNavigate, matchPath } from "react-router-dom"
import DataContext from "../context"

const AccountHeader = ({ heading }) => {
  const contextValues = useContext(DataContext)
  const location = useLocation()
  const navigate = useNavigate()
  const navigateback = (e) => {
    e.preventDefault()

    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };
  const isMatchingRoute = matchPath('/order-online/:slug', location.pathname) || matchPath('/order-online/search/:slug', location.pathname) || matchPath('/order-online', location.pathname);
  return (<>
    <div className="appHeader">
      <div className="left" onClick={(e) => { navigateback(e) }}>
        <button type="button" className="back-button"><i className="ri-arrow-left-line"></i></button>
        <h6 className="mb-0 mt-0 tx-18">{heading}</h6>
      </div>

      {isMatchingRoute && (
        <div className="right">
          <div className="button-group">
            <button type="button" className="icon-button"><i className="ri-search-line"></i></button>
            <button type="button" className="icon-button" onClick={() => navigate('/choose-meal-date')}><i className="ri-shopping-cart-line"></i> {contextValues.cartCount && contextValues.cartCount > 0 ?
              <span className="count">{contextValues.cartCount}</span> : ''
            }</button>
          </div>
        </div>)}

    </div>
  </>)
}

export default AccountHeader